import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
// import { Auth, API } from "aws-amplify";
import { Amplify } from "aws-amplify";
import { createPinia } from "pinia";
//import { library } from "@fortawesome/fontawesome-svg-core";
//import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Vue3EasyDataTable from "vue3-easy-data-table";
import "vue3-easy-data-table/dist/style.css";
import { VueCsvImportPlugin } from "vue-csv-import";
import JsonCSV from "vue-json-csv";
import VuePapaParse from "vue-papa-parse";
import VueApexCharts from "vue3-apexcharts";
// Icons
import { faLaptop } from "@fortawesome/free-solid-svg-icons";
import BreadcrumbEmit from "@/components/BreadcrumbEmit.vue";
import BreadcrumbSeperator from "@/components/BreadcrumbSeperator.vue";
//library.add(faLaptop);

loadFonts();

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolClientId: process.env
        .VUE_APP_AWS_USER_POOL_WEB_CLIENT_ID as string,
      userPoolId: process.env.VUE_APP_AWS_USER_POOL_ID as string,
      loginWith: {
        oauth: {
          domain: process.env.VUE_APP_AWS_OAUTH_DOMAIN as string,
          scopes: [
            "email",
            "openid",
            "aws.cognito.signin.user.admin",
            "profile",
          ],
          redirectSignIn: [
            process.env.VUE_APP_AWS_OAUTH_REDIRECT_SIGN_IN as string,
          ],
          redirectSignOut: [
            process.env.VUE_APP_AWS_OAUTH_REDIRECT_SIGN_OUT as string,
          ],
          responseType: "code",
        },
      },
    },
  },
  API: {
    REST: {
      J24: {
        endpoint:
          "https://8wbfq62cch.execute-api.eu-west-1.amazonaws.com/default/TestFunctionCognito",
      },
      J24Auth: {
        endpoint: process.env.VUE_APP_AUTH_API as string,
      },
      ELA: {
        endpoint: process.env.VUE_APP_ELA_API as string,
      },
      REPAIRS: {
        endpoint: process.env.VUE_APP_REPAIRS_API as string,
      },
    },
  },
});

const pinia = createPinia();

createApp(App)
  .use(pinia)
  .use(router)
  .use(vuetify)
  .use(VueCsvImportPlugin)
  .use(VuePapaParse)
  .use(VueApexCharts)
  // .component("font-awesome-icon", FontAwesomeIcon)
  .component("EasyDataTable", Vue3EasyDataTable)
  .component("downloadCsv", JsonCSV)
  .component("apexchart", VueApexCharts)
  .component("BreadcrumbEmit", BreadcrumbEmit)
  .component("BreadcrumbSeperator", BreadcrumbSeperator)
  .mount("#app");
